import React from "react";
import FooterShell from "../shared/FooterShell";
import { MobileFooterVariantProps } from "../shared/types";

/** Raised Home — 5 tabs + floating Games FAB + CSS raised Home bump */
const RaisedHomeFooter = (
  props: Omit<MobileFooterVariantProps, "footerId">
) => <FooterShell {...props} footerId="default" />;

export default RaisedHomeFooter;
